import { PatientHealthcareAgreement } from "../../models/patient-center/patient-healthcare-agreement.model";

export class PatientHealthcareAgreementStruct extends PatientHealthcareAgreement {
    public nameHealthcareAgreement: string;
    public planName: string;
}